import React from "react";
import BaseButton from "./BaseButton";
import { PlusOutlined } from '@ant-design/icons';

const BaseCreate = (props) => <BaseButton type="primary" className={ "button-right-align" } { ...props } >{ props.text ? props.text : "Create" } { props.icon ? null : <PlusOutlined /> } </BaseButton>

export default BaseCreate;
